import * as Services from "../../Services";
import {
  call,
  put,
  takeLatest,
} from "@redux-saga/core/effects";
import {GET_PACKING_TYPES} from "./Types";
import {PackingTypesActions} from "./Slice";
import PackingType from "../../Models/PackingType";

function* getPackingTypes() {
  try {
    const res =  yield call(Services.getPackingTypes);
    if (!res?.results) {
      throw Error('There was an error.');
    } else {
      const packingTypes = res.results as PackingType[];
      yield put(PackingTypesActions.setPackingTypes(packingTypes));
    }
  } catch (e) {
    console.log(e);
  }
}

export default function* packingTypeSaga() {
  yield takeLatest(GET_PACKING_TYPES, getPackingTypes)
}
